import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";

import { getLayoutById, resetHistory } from "../store/ducks/duckLayout";
import LoadingComponent from "../components/LoadingComponent";
import { getFavorites } from "../store/ducks/duckFavorites";

import LayoutWithTabs from "./LayoutWithTabs";
import LayoutSimple from "./LayoutSimple";

const ProviderLayout = () => {
  const dispatch = useDispatch();

  const { id } = useParams();

  const { tabs } = useSelector((state) => state.layout.layoutSelected);

  const { isLoading } = useSelector((state) => state.layout);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  useEffect(() => {
    dispatch(getLayoutById(id));
    dispatch(getFavorites());

    return () => dispatch(resetHistory()); //Se resetea la historia entre layouts
  }, [dispatch, enqueueSnackbar, history, id]);

  if (isLoading !== undefined) {
    if (isLoading) {
      return <LoadingComponent loading={isLoading} />;
    } else if (id === "1") {
      if (tabs !== undefined && tabs.length > 0) {
        return <LayoutWithTabs />;
      } else {
        return <LoadingComponent loading={isLoading} />;
      }
    } else if (tabs && !isLoading) {
      return <LayoutWithTabs />;
    } else if (!isLoading && !tabs) {
      return <LayoutSimple />;
    } else {
      return <LoadingComponent loading={true} />;
    }
  } else {
    return <LoadingComponent loading={true} />;
  }
};

export default React.memo(ProviderLayout);
